import { useParams } from "react-router-dom";
import ContainerTitulo from "../../../components/Formularios/Container/ContainerTitulo";
import FormEmpresa from "./formEmpresa";

export function EmpresaVisualizar() {
  const idempresa = useParams();
  return (
    <>
      <div className="container-fluid mt-2">
        <ContainerTitulo titulo="Visualizar Empresa" />
        <FormEmpresa idempresa={idempresa.id} acao="Visualizar" />
      </div>
    </>
  );
}
